{
  "usuaris": {
    "accessos": "Accessos",
    "senseRol": "Sense rol: no pot entrar",
    "filtreSenseRol": "Sense rol",
    "filtreModificats": "Amb dades modificades",
    "notaFiltresRapids": "Els filtres ràpids s'apliquen a la pàgina actual.",
    "modificatCai": "Té dades modificades al CAI",
    "syncGlobal": "Sincronitza tots",
    "notaSyncGlobal": "La sincronització global respecta les dades modificades al CAI.",
    "tots": "Tots els departaments",
    "totsRols": "Qualsevol rol",
    "totsEstats": "Qualsevol estat",
    "actius": "Actius",
    "inactius": "Inactius",
    "obreFitxa": "Obre la fitxa de {{nom}}"
  },
  "fitxa": {
    "pestanyes": {
      "perfil": "Perfil",
      "accessos": "Accessos",
      "contacte": "Contacte i dispositius",
      "activitat": "Activitat"
    },
    "ultimSync": "Última sincronització amb Entra ID: {{data}}",
    "maiSync": "Mai sincronitzat amb Entra ID",
    "sincronitza": "Sincronitza amb Entra ID",
    "carregant": "Carregant…"
  },
  "perfil": {
    "dades": "Dades personals",
    "camps": {
      "nom": "Nom",
      "cognoms": "Cognoms",
      "email": "Correu",
      "upn": "Usuari corporatiu",
      "carrec": "Càrrec",
      "departamentId": "Departament",
      "telefon": "Mòbil per als avisos",
      "idioma": "Idioma dels avisos"
    },
    "origen": {
      "entra": "D'Entra ID",
      "cai": "Modificat al CAI",
      "pendent": "Canvi sense desar",
      "bloquejat": "Entra ID"
    },
    "bloquejatTitol": "Només es pot canviar a Entra ID",
    "aEntra": "A Entra ID:",
    "recupera": "Recupera aquest valor",
    "senseValor": "(buit)",
    "avisLocals_one": "Aquesta persona té <b>{{count}} dada modificada al CAI</b>. La sincronització automàtica la respecta; només «Sincronitza amb Entra ID» la substitueix.",
    "avisLocals_other": "Aquesta persona té <b>{{count}} dades modificades al CAI</b>. La sincronització automàtica les respecta; només «Sincronitza amb Entra ID» les substitueix.",
    "totesEntra": "Totes les dades coincideixen amb Entra ID.",
    "estat": "Estat",
    "actiu": "Actiu",
    "inactiu": "Inactiu",
    "ajudaEstat": "Una persona inactiva no rep avisos ni pot entrar. El seu historial es conserva.",
    "desactiva": "Desactiva l'usuari",
    "reactiva": "Reactiva l'usuari",
    "desactivaTitol": "Desactivar «{{nom}}»",
    "reactivaTitol": "Reactivar «{{nom}}»",
    "desactivaText": "Deixarà de rebre avisos i no podrà entrar al CAI. Els seus rols i l'historial es conserven.",
    "reactivaText": "Tornarà a rebre avisos i podrà entrar amb els rols que té assignats.",
    "desat": "Perfil desat.",
    "nomObligatori": "El nom és obligatori."
  },
  "sync": {
    "titol": "Sincronitza amb Entra ID",
    "avis_one": "Se substituirà <b>{{count}} dada modificada al CAI</b> pel valor d'Entra ID. No es pot desfer.",
    "avis_other": "Se substituiran <b>{{count}} dades modificades al CAI</b> pels valors d'Entra ID. No es pot desfer.",
    "senseDiferencies": "No hi ha diferències: només s'actualitzarà la data de sincronització.",
    "dada": "Dada",
    "ara": "Ara (CAI)",
    "quedara": "Quedarà (Entra ID)",
    "descartaPendents": "Els canvis sense desar també es descartaran.",
    "noToca": "Els rols, els canals i els dispositius no es toquen: són dades pròpies del CAI.",
    "substitueix_one": "Substitueix {{count}} dada i sincronitza",
    "substitueix_other": "Substitueix {{count}} dades i sincronitza",
    "sincronitza": "Sincronitza",
    "fet": "Dades sincronitzades amb Entra ID.",
    "carregant": "Comparant amb Entra ID…"
  },
  "accessos": {
    "ajuda": "Cada targeta és un rol. Les etiquetes indiquen <b>on</b> el té; triar una àrea inclou tots els seus serveis.",
    "quePotFer": "Què pot fer ›",
    "treuRol": "Treu el rol",
    "treuRolTitol": "Treure «{{rol}}»",
    "treuRolText": "{{nom}} deixarà de ser {{rol}} a: {{on}}.",
    "enCapLloc": "cap lloc",
    "totaOrganitzacio": "Tota l'organització",
    "donaGlobal": "o dona-li el rol a tota l'organització",
    "limita": "Limita'l a una part",
    "afegeixAmbit": "Afegeix departament, àrea o servei…",
    "afegeixAmbitA": "Afegeix on aplica el rol {{rol}}",
    "treuAmbit": "Treu {{nom}}",
    "encaraEnlloc": "Encara no s'aplica enlloc: afegeix on el té.",
    "afegeixRol": "＋ Afegeix un altre rol…",
    "senseRols": "No té cap rol: no pot entrar al CAI.",
    "nouRol": "Rol nou: tria on s'aplica"
  },
  "rols": {
    "persones_one": "{{count}} persona",
    "persones_other": "{{count}} persones",
    "pestanyes": {
      "permisos": "Permisos",
      "persones": "Persones amb aquest rol",
      "dades": "Dades del rol"
    },
    "queGestiona": "Què pot gestionar",
    "cols": {
      "CONSULTAR": "Veure",
      "ALTA": "Crear",
      "MODIFICAR": "Modificar",
      "ELIMINAR": "Eliminar"
    },
    "noAplica": "No aplica",
    "grupN": "{{n}} de {{total}}",
    "marcaGrup": "Marca tots els permisos de {{grup}}",
    "sistemaAvis": "Rol del sistema: està protegit perquè ningú es quedi sense accés. Duplica'l per fer-ne una variant.",
    "duplica": "Duplica",
    "nou": "Nou rol",
    "elimina": "Elimina",
    "eliminaTitol": "Eliminar el rol «{{rol}}»",
    "eliminaText": "Les persones que el tenen el perdran. No es pot desfer.",
    "duplicaTitol": "Duplicar «{{rol}}»",
    "copiaDe": "Còpia de {{nom}}",
    "duplicaAjuda": "El rol nou tindrà els mateixos permisos. No s'assigna a ningú.",
    "creaRol": "Crea el rol",
    "nouAjuda": "Es crea sense permisos; després marca'ls a la matriu.",
    "codiAjuda": "Identificador curt i únic, en majúscules. No es podrà canviar.",
    "sensePersones": "Ningú té aquest rol.",
    "veure": "Obre la fitxa",
    "dadesDesades": "Dades del rol desades.",
    "permisosDesats": "Permisos desats."
  }
}
